var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"diffModal",attrs:{"id":"diff-dialog","modal-class":_vm.theme,"hide-footer":"","centered":"","body-class":"modal__confirm","size":"lg"}},[_c('ShowDiff',{attrs:{"local":_vm.local,"git":_vm.git,"name":_vm.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }